import React from 'react';
import ReactDOM from 'react-dom';
import {ConnectedRouter} from "connected-react-router";
import {Provider} from 'react-redux';
import {Switch, Route} from 'react-router-dom';
import store, {history} from './redux/store';
import './index.css';
import * as serviceWorker from './serviceWorker';
// import CoverPage from "./containers/CoverPage";
// import FormPage from "./containers/FormPage";
// import GuidePages from "./containers/GuidePages";
import asyncComponent from "./util/asyncComponent";
import CircularProgress from "@material-ui/core/CircularProgress";

const fullScreenLoader = (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
    }}>
        <CircularProgress/>
    </div>
);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path="/"
                       exact
                       component={asyncComponent(() => import('./containers/CoverPage'), fullScreenLoader)}
                />
                <Route path="/form"
                       component={asyncComponent(() => import('./containers/FormPage'), fullScreenLoader)}
                />
                <Route path="/4p"
                       component={asyncComponent(() => import('./containers/GuidePages'), fullScreenLoader)}
                />
            </Switch>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
